(() => {
  const hintId = "hg-external-link-hint";
  const label = document.currentScript.dataset.newWindowLabel;
  const host = value => value.toLowerCase().replace(/^www\./, "");
  const update = link => {
    if (!link.matches("a[href]") || link.hasAttribute("download")) return;
    let url;
    try { url = new URL(link.getAttribute("href"), document.baseURI); } catch { return; }
    if (!["http:", "https:"].includes(url.protocol) || host(url.hostname) === host(location.hostname)) return;
    link.target = "_blank";
    link.relList.add("noopener");
    if (label) {
      const ids = new Set((link.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean));
      ids.add(hintId);
      link.setAttribute("aria-describedby", [...ids].join(" "));
    }
  };
  const scan = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.("a[href]")) update(root);
    root.querySelectorAll("a[href]").forEach(update);
  };
  if (label && !document.getElementById(hintId)) {
    const hint = document.createElement("span");
    hint.id = hintId;
    hint.className = "visually-hidden";
    hint.textContent = label;
    document.body.append(hint);
  }
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === "attributes") update(record.target);
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["href"] });
  ["click", "auxclick"].forEach(type => document.addEventListener(type, event => {
    const link = event.target.closest?.("a[href]");
    if (link) update(link);
  }, true));
})();